export default "__VITE_ASSET__DNxdu2vs__"